<!--
 * @Description:操作日志列表弹层
 * @Date: 2024-04-29 14:15:47
-->
<template>
  <el-dialog
    center
    title="操作日志"
    :visible="true"
    :before-close="closeDialog"
    top="7vh"
    width="1500px"
  >
    <base-table
      :checkData="false"
      :tableColumn="tableColumns"
      :data="tableData"
      height="55vh"
    />
    <base-pagination
      v-model="tablePageQuery"
      :total="tableTotal"
      @input="getTableData"
    />
  </el-dialog>
</template>

<script>
import baseTable from '@R/components/Base/baseTable';
import { taskOptLogList } from '@R/api';
import basePagination from '@R/components/Base/basePagination';

const ENUMS = {
  aspAuditStatus: ['未提交审核', '审核中', '审核通过', '审核未通过'],
  ossAuditStatus: ['未提交审核', '审核中', '审核通过', '审核未通过']
};

const emptyFormatter = ({ val }) => {
  return val || '-';
};

export default {
  name: 'operation-log',
  components: {
    baseTable,
    basePagination
  },
  props: ['projectId', 'projectType', 'taskId'],
  data() {
    return {
      tableSearchQuery: {},
      tableData: [],
      tableLoading: false,

      // 当前表格 内容的筛选条件（点击搜索后的条件）
      tableCurrentQuery: {},
      tableTotal: 0,
      tableCurrentPage: 0,
      tablePageQuery: {
        pageSize: 60,
        pageNo: 1
      },
      tableColumns: [
        {
          prop: 'taskCode',
          label: '任务编码',
          width: '150px'
        },
        {
          prop: 'taskSubmitDt',
          label: '提交时间',
          width: '150px'
        },
        {
          label: '服务商审核状态',
          prop: 'aspAuditStatus',
          formatter: ({ val }) => {
            return ENUMS['aspAuditStatus'][val];
          }
        },
        {
          label: '审核人',
          prop: 'aspAuditUserName',
          formatter: emptyFormatter
        },
        {
          label: '审核时间',
          prop: 'aspAuditDt',
          formatter: emptyFormatter
        },
        {
          label: '驳回原因',
          prop: 'aspAuditOpinion',
          formatter: emptyFormatter
        },
        {
          label: '平台审核状态',
          prop: 'ossAuditStatus',
          formatter: ({ val }) => {
            return ENUMS['ossAuditStatus'][val];
          }
        },
        {
          label: '平台审核时间',
          prop: 'ossAuditDt',
          formatter: emptyFormatter
        },
        {
          label: '平台审核人',
          prop: 'ossAuditUserName',
          formatter: emptyFormatter
        },
        {
          label: '平台驳回原因',
          prop: 'ossAuditOpinion',
          formatter: emptyFormatter
        },
        {
          label: '是否过期',
          prop: 'isOverdue',
          formatter: ({ val }) => {
             return ['否', '是'][val];
          }
        },
        {
          label: '过期时间',
          prop: 'overdueDt'
        },
        {
          label: '过期原因',
          prop: 'overdueReason',
          formatter: emptyFormatter
        }
      ]
    };
  },
  methods: {
    async getTableData() {
      this.tablePageQuery.pageSize = 15;
      const params = {
        taskId: this.taskId,
        projectType: this.projectType,
        projectId: this.projectId,
        ...this.tablePageQuery
      };
      const result = await taskOptLogList(params);
      const {
        data: { list, total }
      } = result.data;
      this.tableData = list;
      this.tableTotal = total;
    },
    closeDialog() {
      this.$emit('close');
    }
  },
  created() {
    this.getTableData();
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-image {
  display: inline-block;
}
</style>
